import { LT_POS } from 'bl/loggers.bl';
import POS_READER_STATUS from 'constants/pos/posReaderStatus.const';
import mockJsonResponse from 'utils/backend/mockJsonResponse.util';
import { isEnvDev } from 'utils/env/determine.util';
import logger from 'utils/logger.util';

const L = logger(['MOCK/barnard', LT_POS]); // eslint-disable-line no-unused-vars

const IS_ENABLED = false;

// ONLY mock while working locally, NEVER when deployed to some other environment
const define = (options, fn) => {
  if (!IS_ENABLED || !isEnvDev()) return void 1;

  const tag = options?.tag;
  L.debug('local()', tag, 'mocking...');

  return (...args) => {
    L.debug('local()', tag, 'calling with args:', args, '...');
    const result = fn(...args);
    L.debug('local()', tag, 'returning result:', result, '...');
    return result;
  };
};

const READER_BE_ID = 21;
const READER_STRIPE_ID = 'tmr_barnard';
const LOCATION_STRIPE_ID = 'tml_barnard';
const READER_NAME = 'Main reader';

export const mock$beFindReaderV1 = define({ tag: 'barnard step 1a beFindReaderV1' }, () =>
  mockJsonResponse({
    body: {
      reader: READER_STRIPE_ID,
      reader_status: POS_READER_STATUS.online,
    },
  }),
);

export const mock$beFindReaderV3 = define({ tag: 'barnard step 1b beFindReaderV3' }, () =>
  mockJsonResponse({
    body: {
      _v: 3,
      results: {
        readers: [
          {
            id: READER_BE_ID,
            reader: READER_STRIPE_ID,
            status: POS_READER_STATUS.online,
            is_main: false,
            name: READER_NAME,
            type: null,
            stylist: '',
            stylist_id: null,
            location_id: LOCATION_STRIPE_ID,
          },
        ],
      },
    },
  }),
);

export const mock$beInitReaderPayment = define({ tag: 'barnard step 2 beInitReaderPayment' }, () =>
  mockJsonResponse({
    body: {
      intent_id: 'pi_barnard',
      client_secret: 'pi_barnard_secret_barnard-secret',
    },
  }),
);

export const mock$beGetPosIntentStatus = define({ tag: 'barnard step 3 beGetPosIntentStatus' }, () =>
  mockJsonResponse({
    body: {
      message: 'Payment successfull.Complete the transaction',
      code: 'POS200',
      intent_id: 'pi_barnard',
      reason: '',
    },
  }),
);
